import messagesJa from "./ja/messages.ja";
import messagesEn from "./en/messages.en";
import messagesTw from "./zhTw/messages.zhTw";

export default {
  ja: messagesJa,
  en: messagesEn,
  "zh-TW": messagesTw,
};
